import { render } from "./ChecklistUser.vue?vue&type=template&id=25feab8b"
import script from "./ChecklistUser.vue?vue&type=script&lang=js"
export * from "./ChecklistUser.vue?vue&type=script&lang=js"
script.render = render

export default script